import styled from 'styled-components';

interface StationPageContainerProps {
  $isMobile: boolean;
}

export const StationPageContainer = styled.div<StationPageContainerProps>`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  height: 100%;
  width: 100%;
  ${({ $isMobile }) => $isMobile && 'margin-top: 46px;'}
`;
